import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { AnbieterService } from '../../../services/facetten/instance/anbieter.service';

import { CheckboxFacetteComponent } from '../../checkbox-facette/checkbox-facette.component';
import { FilterSelectItem } from '../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-anbieter-facette',
  templateUrl: './anbieter-facette.component.html',
  imports: [BasisFacetteComponent, CommonModule, CheckboxFacetteComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnbieterFacetteComponent {
  facettenService = inject(AnbieterService);
  loaderService = inject(LoaderService);

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService.getSelectItems$();
  public count$ = this.facettenService.getNumberSelected$();

  public updateSelectedIds(selecteItems: FilterSelectItem[]): void {
    const selectedIds = selecteItems.map((item) => item.key);
    this.facettenService.updateSelectedIds(selectedIds);
  }
}
